import ApiClient from '@/services/apiClient';
import moment from 'moment';
import i18n from '@/i18n';

export default class ExtensionModule {
    id;
    label;
    serial_number;
    module_type;
    module_state;
    module_version;
    warranty_start_date;
    is_active;

    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ExtensionModule();
            obj.id = ApiClient.convertToType(data['id'], 'Integer');
            obj.label = ApiClient.convertToType(data['label'], 'String');
            obj.serial_number = ApiClient.convertToType(data['serial_number'], 'Integer');
            obj.module_type = ApiClient.convertToType(data['module_type'], 'String');
            obj.module_state = ApiClient.convertToType(data['module_state'], 'Integer') || 0;
            obj.module_version = ApiClient.convertToType(data['module_version'], 'Integer') || 0;
            obj.warranty_start_date = ApiClient.convertToType(data['warranty_start_date'], 'Date');
            obj.is_active = ApiClient.convertToType(data['is_active'], 'Boolean');
        }
        return obj;
    }

    toJSON() {
      return {
        label: this.label,
        serial_number: this.serial_number,
        module_type: this.module_type,
        is_active: this.is_active,
      };
    }

    toString() {
        return this.label;
    }

    get type_as_string() {
      switch(this.module_type) {
        case "Relay":
          return i18n.global.t('extensionModule.relay');
        case "Reader":
          return i18n.global.t('extensionModule.reader');
        default:
          return i18n.global.t('extensionModule.unknown');
      }
    }

    key(hubId) {
      return `Extension_${hubId}_${this.id}`;
    }

    path(facilityId, hubId) {
      return {path: '/component-edit-extension', params: { facilityId: facilityId, hubId: hubId, id: this.id }};
    }

    get documentationUrl() {
      return "assets/datasheets/relays.pdf";
    }

    get getVersions() {
      return this.module_version == 0? "-" : this.module_version.toString(16).split('').join('.');
    }

    get getWarrantyStartDate() {
      return moment(this.warranty_start_date).format('DD/MM/YYYY');
    }

    get getSerialNumber() {
      const aa = (this.serial_number >>> 24) & 0xFF;
      const bb = (this.serial_number >>> 16) & 0xFF;
      const cc = (this.serial_number >>> 8) & 0xFF;
      const dd = this.serial_number & 0xFF;
      const cpl = (aa + bb + cc + dd) & 0xFF;

      const hex2 = (v) => v.toString(16).toUpperCase().padStart(2, '0');

      return `HX:${hex2(aa)}:${hex2(bb)}:${hex2(cc)}:${hex2(dd)}:${hex2(cpl)}`;     
    }
  }
